import { render, staticRenderFns } from "./SpeedTest.vue?vue&type=template&id=7a8339dc&scoped=true&"
import script from "./SpeedTest.vue?vue&type=script&lang=js&"
export * from "./SpeedTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a8339dc",
  null
  
)

export default component.exports